import validator from 'validator';

export function validateEmail(email: string): boolean {
  return validator.isEmail(email);
}

export function isEmpty(value: string): boolean {
  return validator.isEmpty(value.trim());
}
